import React, { useEffect, useState } from "react";
import CustomButton from "./CustomButton";
import { useHistory, useLocation } from "react-router-dom";
import { APP_COLOR } from "../const";
import { FaBalanceScale, FaChartBar, FaRegUser } from "react-icons/fa";

export default function NavDashboard({ children, title, mainHeight, mainBg }) {
  const history = useHistory();
  const Location = useLocation();

  // console.log('JJJJJJ', Location)
  const [activeButton, setActiveButton] = useState();

  const handleButtonClick = (buttonName) => {
    history.push(`/${buttonName}`);
  };
  useEffect(() => {
    setActiveButton(Location.pathname);
  }, [Location.pathname]);

  return (
    <>
      {/* <NavBarHeader title="ລາຍງານ" /> */}
      <div style={{ width: "100%", height: mainHeight ? mainHeight : "", background: mainBg ? mainBg : '' }}>
        <div
          style={{
            display: "flex",
            position: "fixed", right: 0, top: 0, zIndex: 999, width: "100%", paddingLeft: "3em", borderBottom: "1px solid #f1f1f1"
          }}>
          <div style={{ width: "100%", background: "#FFFFFF" }}>
            <div
              style={{
                display: "flex",
                // flexDirection: "column",
                // justifyContent: "flex-start",
              }}>
              <CustomButton
                onClick={() => handleButtonClick("dashboard")}
                title="ຍອດຂາຍວັນນີ້"
                background={
                  activeButton === "/dashboard"
                    ? "#f2f2f2"
                    : "white"
                }
                color={activeButton === "/dashboard" ? APP_COLOR : "black"}
                height="56px"
                icon={<FaChartBar />}
              />
              <CustomButton
                onClick={() => handleButtonClick("report_income")}
                title="ຕົ້ນທຶນ ເເລະ ກຳໄລ"
                background={
                  activeButton === "/report_income"
                    ? "#f2f2f2"
                    : "white"
                }
                color={
                  activeButton === "/report_income" ? APP_COLOR : "black"
                }
                height="56px"
                icon={<FaBalanceScale />}
              />
              {/* <CustomButton
                onClick={() => handleButtonClick("reportcategory")}
                title="ລາຍງານຕາມປະເພດສິນຄ້າ"
                background={
                  activeButton === "/reportcategory"
                    ? "#f2f2f2"
                    : "white"
                }
                color={activeButton === "/reportcategory" ? APP_COLOR : "black"}
                height="56px"
              />
              <CustomButton
                onClick={() => handleButtonClick("reportproduct")}
                title="ລາຍງານການຂາຍສິນຄ້າ"
                background={
                  activeButton === "/reportproduct"
                    ? "#f2f2f2"
                    : "white"
                }
                color={activeButton === "/reportproduct" ? APP_COLOR : "black"}
                height="56px"
              />
              <CustomButton
                onClick={() => handleButtonClick("reportproductsaleout")}
                title="ລາຍງານສິນຄ້າຂາຍບໍ່ອອກ"
                background={
                  activeButton === "/reportproductsaleout"
                    ? "#f2f2f2"
                    : "white"
                }
                color={
                  activeButton === "/reportproductsaleout" ? APP_COLOR : "black"
                }
                height="56px"
              /> */}
              <CustomButton
                onClick={() => handleButtonClick("report_staff/limit/50/page/1")}
                title="ຍອດຂາຍຕາມພະນັກງານ"
                background={
                  activeButton === "/report_staff/limit/50/page/1"
                    ? "#f2f2f2"
                    : "white"
                }
                color={activeButton === "/report_staff/limit/50/page/1" ? APP_COLOR : "black"}
                height="56px"
                icon={<FaRegUser />}
              />
            </div>
          </div>
        </div>
        <div
          style={{
            width: "100%", padding: "2em", paddingTop: "5em", paddintBottom: "4em"
          }}>
          {children}
        </div>
      </div>
    </>
  );
}
